//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertErrorNotify from "components/DialogAlertNotify/v2/DialogAlertErrorNotify";
//#endregion
//#region Images
import errorImage1 from "img/error_image_1.svg";
//#endregion

const DialogAlertErrorSimple = ({
    dialog, title, content
}) => {
    return (
        <DialogAlertErrorNotify
			dialog={dialog}
            content={{
                value: content,
                title: title,
                image: <img src={errorImage1} alt="Error"/>,
                widthParagraph: "90%"
            }}>
            <CustomButton 
                text="Cerrar"
                width="85px"
                onClick={dialog.hide}/>
        </DialogAlertErrorNotify>
    );
}

export default DialogAlertErrorSimple;